import { useEffect, useState } from "react";

import { PageViewPayload } from "./PageViewPayload.model";

const constructMessage = (payload: PageViewPayload) => {
  return {
    type: "PAGE_VIEW",
    payload: payload,
  };
};

type UsePageViewMessageParams = {
  sendMessage: (message: any) => void;
  pageViewPayload: PageViewPayload;
  loading?: boolean;
};

export const usePageViewMessage = ({
  sendMessage,
  pageViewPayload,
  loading,
}: UsePageViewMessageParams): PageViewPayload => {
  const [isSent, setIsSent] = useState(false);
  useEffect(() => {
    if (!loading && !isSent) {
      sendMessage(constructMessage(pageViewPayload));
      setIsSent(true);
    }
  }, [loading, isSent, sendMessage, pageViewPayload]);
  return constructMessage(pageViewPayload).payload;
};
